
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations",
      function () {
        return require("private-next-pages/destinations.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations"])
      });
    }
  